import { useSyncExternalStore } from 'react';
import { Alert, AlertVariants, AlertAppearances, AlertOrientations } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { notification } from '@/lib/notifications';
import styles from './NotificationHost.module.scss';

// Mounted once by providers.jsx — the only place notifications render.
export const NotificationHost = () => {
  const t = useTranslations();
  const items = useSyncExternalStore(notification.subscribe, notification.getSnapshot);

  if (items.length === 0) return null;

  return (
    <div className={styles.host} role="status" aria-live="polite">
      {items.map((item) => (
        <Alert
          key={item.id}
          className={styles.item}
          variant={AlertVariants[item.variant] ?? AlertVariants.info}
          appearance={AlertAppearances.accent}
          orientation={AlertOrientations.horizontal}
          title={item.title}
          onDismiss={() => notification.dismiss(item.id)}
          dismissLabel={t('COMMON_CLOSE')}
        >
          {item.message}
        </Alert>
      ))}
    </div>
  );
};
